import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'notice-type-colour',
    template: `
        <div class="status-icon-block right-buffer">
            <div class="status-icon">
                <div
                    *ngIf="colour"
                    [ngStyle]="{ 'background-color': colour }"
                ></div>
            </div>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoticeTypeColourComponent {
    @Input() colour: string | null | undefined;
}
